import { useContext } from 'react';
import interpolateComponents from 'interpolate-components';
import { NEED_HELP } from 'src/common/constants/localizations/auth';
import UnderlineLink from '../../shared/link/UnderlineLink';

import authCss from '../auth.module.scss';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';

const NeedHelp = () => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <p data-testid="needHelp" key="needHelp" className={authCss.infoText}>
      {interpolateComponents({
        mixedString: getLocalizedText(NEED_HELP),
        components: {
          a: (
            <UnderlineLink
              role="button"
              tabIndex="0"
              key="emailLink"
              className={authCss.link}
              to="mailto:support@tunein.com"
              isDropDown
              isNotReactRouterLink
            />
          ),
        },
      })}
    </p>
  );
};

export default NeedHelp;
